import Vue from "vue";
import VueRouter from "vue-router";

import store from "./store";

import { isWeixin } from "./functions";

const needLogin = !isWeixin()

class Router extends VueRouter {
  constructor(props) {
    super(props);
    this.isBack = false;
  }

  push(location, onComplete, onAbort) {
    this.isBack = false;
    super.push(location, onComplete, onAbort);
  }

  back() {
    this.isBack = true;
    super.back();
  }
}

Vue.use(Router);

const routes = [
  {
    path: "*",
    redirect: "/tabs/home",
  },
  {
    name: "login",
    path: "/login",
    component: () => import("./view/Login.vue"),
    meta: {
      title: "登陆",
    },
  },
  {
    name: "tabs",
    component: () => import("./view/tabs"),
    meta: {
      title: "主页",
      keepAlive: false,
    },
    children: [
      {
        name: "home",
        path: "home",
        component: () => import("./view/home"),
        meta: {
          title: "首页",
          keepAlive: false,
        },
      },
      {
        name: "market",
        path: "market",
        component: () => import("./view/market"),
        meta: {
          title: "服务市场",
          keepAlive: false,
        },
      },
      {
        name: "trend",
        path: "trend",
        component: () => import("./view/trend"),
        meta: {
          title: "行情走势",
          keepAlive: false,
        },
      },
      {
        name: "tradeLeads",
        path: "tradeLeads",
        component: () => import("./view/tradeLeads"),
        meta: {
          title: "供求大厅",
          keepAlive: false,
          // needLogin,
        },
      },
      {
        name: "about",
        path: "about",
        component: () => import("./view/about"),
        meta: {
          title: "我的",
          keepAlive: false,
          needLogin,
        },
      },
      {
        name: "sheng_ri_jiu",
        path: "sheng_ri_jiu",
        component: () => import("./view/sheng_ri_jiu"),
        meta: {
          title: "生日酒",
          keepAlive: false,
        },
      }
    ],
  },
  {
    name: "tradeLeadNew",
    path: "/tradeLeadNew",
    component: () => import("./view/tradeLeadNew"),
    meta: {
      title: "编辑供求",
      keepAlive: false,
    },
  },
  {
    name: "clear",
    path: "/clear",
    component: () => import("./view/clear"),
    meta: {
      title: "清除缓存",
      keepAlive: false,
    },
  },
  {
    name: "tradeLeadMessageList",
    path: "/tradeLeadMessageList",
    component: () => import("./view/tradeLeadMessageList"),
    meta: {
      title: "未读消息",
      keepAlive: false,
    },
  },
  {
    name: "tradeLeadLike",
    path: "/tradeLeadLike",
    component: () => import("./view/tradeLeadLike"),
    meta: {
      title: "点赞详情",
      keepAlive: false,
    },
  },
  {
    name: "tradeLeadDetail",
    path: "/tradeLeadDetail",
    component: () => import("./view/tradeLeadDetail"),
    meta: {
      title: "详情",
      keepAlive: false,
    },
  },
  {
    name: "goodDetail",
    path: "/goodDetail",
    component: () => import("./view/goodDetail"),
    meta: {
      title: "商品详情",
      keepAlive: false,
    },
  },
  {
    name: "trendDetail",
    path: "/trendDetail",
    component: () => import("./view/trendDetail"),
    meta: {
      title: "行情走势",
      keepAlive: false,
    },
  },
  {
    name: "newsDetail",
    path: "/newsDetail",
    component: () => import("./view/news"),
    meta: {
      title: "行情头条",
      keepAlive: false,
    },
  },
  {
    name: "register",
    path: "/register",
    component: () => import("./view/register"),
    meta: {
      title: "绑定手机号",
      keepAlive: false,
    },
  },
  {
    name: "orderPay",
    path: "/orderPay",
    component: () => import("./view/orderPay"),
    meta: {
      title: "确认订单",
      keepAlive: false,
    },
  },
  {
    name: "orderList",
    path: "/orderList",
    component: () => import("./view/orderList"),
    meta: {
      title: "订单列表",
      keepAlive: false,
    },
  },
  {
    name: "orderDetail",
    path: "/orderDetail",
    component: () => import("./view/orderDetail"),
    meta: {
      title: "订单详情",
      keepAlive: false,
    },
  },
  {
    name: "buyCar",
    path: "/buyCar",
    component: () => import("./view/buyCar"),
    meta: {
      title: "购物车",
      keepAlive: false,
    },
  },
  {
    name: "orderPayList",
    path: "/orderPayList",
    component: () => import("./view/orderPayList"),
    meta: {
      title: "购物车列表",
      keepAlive: false,
    },
  },
  {
    name: "paySuccess",
    path: "/paySuccess",
    component: () => import("./view/paySuccess"),
    meta: {
      title: "支付成功",
      keepAlive: false,
    },
  },
];

// add route path
routes.forEach((route) => {
  route.path = route.path || "/" + (route.name || "");
});

const router = new Router({ routes });

router.beforeEach(({ name, meta }, _from, next) => {
  if (!isWeixin() && name !== "login") {
    // 验证路由 meta 中是否开启登陆验证
    if (meta?.needLogin && !store.getters.hasLogin)
      return router.push({ name: "login" });
  }

  next();
});

// router.afterEach((to, from, next) => {
//   // window.document.title = to.meta.title;
// });

export default router;
